module.exports = __webpack_public_path__ + "img/9791185359236.31fdfc13.jpg";